// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-section {
    background-color: #150924;
    color: white;
    padding: 4rem 0;
}

.footer-content-wrap {
    padding: 0;
}

.footer-top {
    padding: 50px 150px;
    margin-left: 0;
    margin-right: 0;
}

.footer-left h2 {
    color: white;
    margin: 27px 0px 24px;
    font-size: 24px;
    display: block;
}

.app-buttons {
    display: block;
}

.app-buttons img {
    width: 140px;
    margin-right: 1rem;
}

.footer-right {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 2rem;
    flex-wrap: wrap;
}

.footer-links {
    display: flex;
    flex-direction: column;
}

.footer-links a {
    color: white;
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    margin-bottom: 12px;
    text-decoration: none;
}

.footer-links a:hover {
    text-decoration: none !important;
}

.footer-right .title {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 20px;
    text-align: left;
    font-family: "Inter", sans-serif;
}

.social-icons {
    display: flex;
    justify-content: flex-end;
    margin-top: 74px;
    margin-bottom: 31px;
}

.social-icons a {
    margin-left: 18px;
}

.footer-bottom {
    padding: 0px 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 2rem;
    /* border-top: 1px solid rgba(255, 255, 255, 0.1); */
}

.footer-bottom p {
    margin: 0;
}

.footer-terms {
    display: block;
}

.footer-terms a {
    color: white;
    margin-left: 1.5rem;
    text-decoration: none;
}

.footer-terms a:hover {
    text-decoration: none !important;
}

.border-footer {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-terms-mob {
    display: none;
}

/* Responsive Styles */
@media (max-width: 768px) {
    .footer-top {
        flex-direction: column;
        align-items: center;
        padding: 50px 0px;
    }

    .footer-left {
        text-align: center;
        margin-bottom: 2rem;
    }

    .app-buttons {
        justify-content: center;
    }

    .footer-right {
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        margin-bottom: 2rem;

    }

    .footer-right .title {
        text-align: center;
        font-size: 12px;
        font-weight: 700;
    }

    .footer-links {
        text-align: center;
    }

    .social-icons {
        justify-content: center;
        margin: 2rem 0;
    }

    .footer-bottom {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .footer-bottom p {
        margin-bottom: 1rem;
    }

    .footer-terms {
        margin-top: 1rem;
        display: none;
    }

    .app-buttons {
        display: none;
    }

    .footer-section {
        padding: 0px;
    }

    .footer-terms-mob {
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;

    }

    .footer-terms-mob a {
        color: white !important;
        font-size: 12px;
        line-height: 24px;
        font-weight: 400;
        margin-bottom: 26px !important;
    }
}

@media (max-width: 480px) {
    .footer-left h2 {
        display: none;
        font-size: 20px;
    }

    .app-buttons img {
        width: 120px;
    }

    .footer-links a {
        font-size: 12px;
    }

    .footer-bottom p {
        font-size: 14px;
    }

    .footer-terms a {
        font-size: 14px;
        margin-left: 1rem;
    }

    .footer-bottom {
        padding: 20px 0px 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,oDAAoD;AACxD;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;QACT,mBAAmB;;IAEvB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,sBAAsB;QACtB,kBAAkB;;IAEtB;;IAEA;QACI,uBAAuB;QACvB,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".footer-section {\n    background-color: #150924;\n    color: white;\n    padding: 4rem 0;\n}\n\n.footer-content-wrap {\n    padding: 0;\n}\n\n.footer-top {\n    padding: 50px 150px;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.footer-left h2 {\n    color: white;\n    margin: 27px 0px 24px;\n    font-size: 24px;\n    display: block;\n}\n\n.app-buttons {\n    display: block;\n}\n\n.app-buttons img {\n    width: 140px;\n    margin-right: 1rem;\n}\n\n.footer-right {\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-start;\n    gap: 2rem;\n    flex-wrap: wrap;\n}\n\n.footer-links {\n    display: flex;\n    flex-direction: column;\n}\n\n.footer-links a {\n    color: white;\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 400;\n    margin-bottom: 12px;\n    text-decoration: none;\n}\n\n.footer-links a:hover {\n    text-decoration: none !important;\n}\n\n.footer-right .title {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    padding-bottom: 20px;\n    text-align: left;\n    font-family: \"Inter\", sans-serif;\n}\n\n.social-icons {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 74px;\n    margin-bottom: 31px;\n}\n\n.social-icons a {\n    margin-left: 18px;\n}\n\n.footer-bottom {\n    padding: 0px 150px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 2rem;\n    /* border-top: 1px solid rgba(255, 255, 255, 0.1); */\n}\n\n.footer-bottom p {\n    margin: 0;\n}\n\n.footer-terms {\n    display: block;\n}\n\n.footer-terms a {\n    color: white;\n    margin-left: 1.5rem;\n    text-decoration: none;\n}\n\n.footer-terms a:hover {\n    text-decoration: none !important;\n}\n\n.border-footer {\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.footer-terms-mob {\n    display: none;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n    .footer-top {\n        flex-direction: column;\n        align-items: center;\n        padding: 50px 0px;\n    }\n\n    .footer-left {\n        text-align: center;\n        margin-bottom: 2rem;\n    }\n\n    .app-buttons {\n        justify-content: center;\n    }\n\n    .footer-right {\n        flex-direction: column;\n        align-items: center;\n        gap: 1rem;\n        margin-bottom: 2rem;\n\n    }\n\n    .footer-right .title {\n        text-align: center;\n        font-size: 12px;\n        font-weight: 700;\n    }\n\n    .footer-links {\n        text-align: center;\n    }\n\n    .social-icons {\n        justify-content: center;\n        margin: 2rem 0;\n    }\n\n    .footer-bottom {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    .footer-bottom p {\n        margin-bottom: 1rem;\n    }\n\n    .footer-terms {\n        margin-top: 1rem;\n        display: none;\n    }\n\n    .app-buttons {\n        display: none;\n    }\n\n    .footer-section {\n        padding: 0px;\n    }\n\n    .footer-terms-mob {\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n        text-align: center;\n\n    }\n\n    .footer-terms-mob a {\n        color: white !important;\n        font-size: 12px;\n        line-height: 24px;\n        font-weight: 400;\n        margin-bottom: 26px !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .footer-left h2 {\n        display: none;\n        font-size: 20px;\n    }\n\n    .app-buttons img {\n        width: 120px;\n    }\n\n    .footer-links a {\n        font-size: 12px;\n    }\n\n    .footer-bottom p {\n        font-size: 14px;\n    }\n\n    .footer-terms a {\n        font-size: 14px;\n        margin-left: 1rem;\n    }\n\n    .footer-bottom {\n        padding: 20px 0px 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
